import React from "react";
// Styles
import styled from "styled-components";
// State
import { useSelector } from "react-redux";
import { selectMode } from "../app/appSlice";
import { selectProjects, selectMainProjects } from "../app/projectsSlice";
import { useGetProjectsQuery } from "../app/apiSlice";
import PropTypes from "prop-types";
// Router
import { Link } from "react-router-dom";
// Components
import { Element } from "react-scroll";
import { Button, Col, Container, Row } from "react-bootstrap";
import Loading from "./Loading";
import Title from "./Title";
import ProjectCard from "./ProjectCard";
import TypeTester from "./TypeTester/TypeTester";

import hoopHelixScreenshot1 from "../images/hoop-helix-team-profile-page.png";
// #region component

const propTypes = {
  projectsIntro: PropTypes.string,
  specimenLabIntro: PropTypes.string,
  hoopHelixIntro: PropTypes.string,
  hoopHelixMore: PropTypes.string,
};

const Projects = ({ projectsIntro, specimenLabIntro, hoopHelixIntro, hoopHelixMore }) => {
  const theme = useSelector(selectMode);
  const projects = useSelector(selectProjects);
  const mainProjects = useSelector(selectMainProjects);
  const { isLoading, isSuccess, isError, error } = useGetProjectsQuery();
  let content;

  if (isLoading) {
    content = (
      <Container className="d-flex">
        <Loading />
      </Container>
    );
  } else if (isSuccess) {
    content = (
      <>
        {!error && projects.length === 0 && (
          <h2 className="text-center">
            Oops, you do not have any GitHub projects yet...
          </h2>
        )}
        {mainProjects.length !== 0 && (
          <>
            <Row xs={1} md={3} lg={3} className="mt-4 g-4 justify-content-center">
              {mainProjects.map((element) => {
                return (
                  <Col key={element.id}>
                    <ProjectCard
                      image={element.image}
                      name={element.name}
                      description={element.description}
                      url={element.html_url}
                      demo={element.homepage}
                    />
                  </Col>
                );
              })}
            </Row>
          </>
        )}
      </>
    );
  } else if (isError) {
    content = (
      <Container className="d-flex align-items-center justify-content-center">
        <h2>{`${error.status} - check getProjects query in src/app/apiSlice.js`}</h2>
      </Container>
    );
  }

  // #region styled-components
  const StyledSProjects = styled.section`
    .title {
      color: ${({ theme }) => theme.name === "light" ? "#000" : "var(--primary-light-blue)"};
    }
    .text-color {
      color: ${({ theme }) => theme.name === "light" ? "#000" : "var(--primary-light-blue)"};
    }
    .btn {
      &:hover {
        background-color: ${({ theme }) => theme.name === "light" ? "#000" : "var(--primary-light-blue)"};
        color: ${({ theme }) => theme.name === "light" ? "#fff" : "#000"};
      }
    }
    
    #hoop-helix .project-intro {
      margin-bottom: 8rem;
    }

    .project-shot-wrap {
      margin-top: 3.5rem;
      width: 100%;
    }

    .project-shot {
      display: block;
      width: 100%;
      height: auto;
    }

    .project-shot-caption {
      margin-top: 0.5rem;
      font-size: 0.8rem;
      color: ${({ theme }) =>
        theme.name === "light" ? "rgba(0, 0, 0, 0.55)" : "rgba(165, 214, 255, 0.6)"};
    }
  `;
  // #endregion

  return (
    <Element name={"Projects"} id="projects">
      <StyledSProjects className="section">
        <Container>
          <Container className="d-flex justify-content-center">
            <Title size={"h2"} text={"Projects"} color={"light-blue"} />
          </Container>

          <Container className="mt-3">
            <Row className="project-intro justify-content-center text-color mt-3">
              <Col lg={8}>
                {projectsIntro &&
              <p className="text-font-regular text-color">
                {projectsIntro}
              </p>
            }
              </Col>
            </Row>
          </Container>

          <Container id="hoop-helix" className="project-container mt-5">
            <Row className="project-intro justify-content-center text-color mt-3">
              <Col lg={8}>
                <h3 className="text-font-semibold">Hoop Helix</h3>

               {hoopHelixIntro &&
                  <p className="text-font-regular">
                    {hoopHelixIntro}
                  </p>
                }

                {hoopHelixMore &&
                  <p className="text-font-regular">
                    {hoopHelixMore}
                  </p>
                }

                <div className="d-flex gap-3 mt-3">
                  <Button
                    as="a"
                    href="https://hoop-helix.onrender.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Live Demo
                  </Button>
                  <Button
                    as="a"
                    href="https://github.com/raquelcps/nba-hoop-helix-playoffs-app-dup"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    GitHub
                  </Button>
                </div>
  
                <div className="project-shot-wrap">
                  <img
                    className="project-shot"
                    src={hoopHelixScreenshot1}
                    alt="Hoop Helix team profile page screenshot"
                  />
                  <p className="project-shot-caption text-font-regular">
                    Hoop Helix Team Profile page
                  </p>
                </div>
              </Col>
            </Row>
          </Container>

          <Container id="specimen-lab" className="project-container mt-5">
            <TypeTester
              specimenLabIntro={specimenLabIntro}
            />
          </Container>

        </Container>
      </StyledSProjects>
    </Element>
  );
};

Projects.propTypes = propTypes;
// #endregion

export default Projects;
